import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TpETLObjectTypes } from '../../etl-data-types/interfaces';
import { TpETLComponentTypeManifest } from '../interfaces';
import {
  TpETLPipelineComponent,
  TpETLDryRun,
  TpETLDryRunComponentResult,
  TpETLDryRunTableObject,
} from '../../interfaces';
import { addDryRunObjectTable } from '../../utils';
import { getETLDryRunObject } from '../../etlDryRun';

function performDryRun(dryRun: TpETLDryRun, comp: TpETLPipelineComponent): TpETLDryRunComponentResult {
  const outputTableObj = addDryRunObjectTable(dryRun, comp.outputObjectIds['result'], comp);
  const inputTableObjects = Object.values(comp.inputObjectIds).map(
    (objId) => getETLDryRunObject(dryRun, objId) as TpETLDryRunTableObject,
  );
  const usedColIds: { [id: string]: boolean } = {};
  for (const tableObj of inputTableObjects) {
    for (const col of tableObj.columns) {
      if (!usedColIds[col.identifier]) {
        outputTableObj.columns.push(structuredClone(col));
        usedColIds[col.identifier] = true;
      }
    }
  }

  return {
    abort: false,
  };
}

export const manifestETLAppendTables: TpETLComponentTypeManifest = {
  id: 'AppendTables',
  name: 'Append Two Tables',
  description: 'Combines two tables by appending their content.',
  categoryId: 'table',
  icon: <FontAwesomeIcon icon={['fas', 'merge']} />,
  performDryRun,
  inputs: [
    {
      type: TpETLObjectTypes.TABLE,
      id: 'sourceTable1',
      name: 'Source Table 1',
      columns: [],
    },
    {
      type: TpETLObjectTypes.TABLE,
      id: 'sourceTable2',
      name: 'Source Table 2',
      columns: [],
    },
  ],
  outputs: [
    {
      id: 'result',
      name: 'Result table',
      type: TpETLObjectTypes.TABLE,
      description: 'Table with the two source tables appended',
      columns: [],
    },
  ],
  params: [],
};
